import { createFileRoute } from "@tanstack/react-router";

import { AdminInstancesPage } from "@/components/admin/AdminInstancesPage";

export const Route = createFileRoute("/admin/instances")({
  head: () => ({ meta: [{ title: "Company instances · GENRL Admin" }] }),
  component: AdminInstancesPage,
});
